import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { store } from 'store';
import _ from 'lodash';
import { removeWorkspace } from 'store/workspaceSlice';

import { updateWorkspaceToken } from 'store/workspaceSlice';

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  const token = JSON.parse(localStorage.getItem('token') || '{}');
  if (config.headers === undefined) {
    config.headers = {};
  }

  const state = store.getState();
  const externalToken = localStorage.getItem('externalToken') || '';
  const workspaces = localStorage.getItem('workspaces') || '[]';
  const sessionWorkspace = sessionStorage.getItem('workspace') || localStorage.getItem('last-active:workspace');
  const activeWorkspace = _.find(JSON.parse(workspaces), { workspace_id: sessionWorkspace });

  if (externalToken && state.app.external) {
    config.headers['Authorization'] = `Bearer ${externalToken}`;
  } else {
    if (token?.access) {
      if (activeWorkspace && activeWorkspace.user) {
        config.headers['Authorization'] = `Bearer ${activeWorkspace.user.access}`;
      } else {
        config.headers['Authorization'] = `Bearer ${token?.access}`;
      }
    }
  }
  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const onResponse = (response: AxiosResponse): AxiosResponse => {
  return response;
};

const clearLocalStorageExcept = (tokensToKeep: string[]) => {
  const keysToKeep = new Set(tokensToKeep); // Store tokens to keep in a Set for faster lookups

  Object.keys(localStorage).forEach((key) => {
    if (!keysToKeep.has(key)) {
      // Check if key is not present in tokensToKeep set
      localStorage.removeItem(key);
    }
  });
};

let refreshInProgress = false;
const onResponseError = async (error: AxiosError): Promise<AxiosError> => {
  const dispatch = store.dispatch;
  const state = store.getState();
  const sessionWorkspace = sessionStorage.getItem('workspace');
  const workspaces = localStorage.getItem('workspaces') || '[]';
  const activeWorkspace = _.find(JSON.parse(workspaces), { workspace_id: sessionWorkspace });

  if (error.response && error.response.status === 401 && !refreshInProgress) {
    try {
      refreshInProgress = true;
      if (!state.app.external && activeWorkspace && activeWorkspace.user.refresh) {
        const API_URL = activeWorkspace.url;
        const rs = await axios.post(`${API_URL}/api/token/refresh/`, {
          refresh: activeWorkspace?.user.refresh
        });
        const token = rs.data;
        if (token) {
          if (activeWorkspace) {
            const payload = {
              ...token,
              ['workspaceId']: activeWorkspace.workspace_id
            };
            dispatch(updateWorkspaceToken(payload));
          }
        }
        localStorage.setItem('token', JSON.stringify(token));
      }
    } catch (error) {
      console.log('Error occurred during token refresh:', error);
      // Handle error if token refresh fails
      clearLocalStorageExcept(['externalToken', 'workspaces']);
      if (activeWorkspace && activeWorkspace.url) {
        dispatch(removeWorkspace(activeWorkspace));
        window.location.replace(activeWorkspace?.url + '/logout');
      }
      return Promise.reject(error);
    } finally {
      refreshInProgress = false; // Reset flag when the request is completed (success or failure)
    }
  }

  return Promise.reject(error);
};

export const setupInterceptorsTo = (axiosInstance: AxiosInstance): AxiosInstance => {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
};
